import { h, Fragment } from "preact";
import stockMessage from "../../helpers/stockMessage/stockMessage";
import StockMessageContent from "./stock-message-content";
import dayjs from "dayjs";

const convertToCST = (dateString) =>
  dateString ? `${dateString}T12:00-06:00` : dateString;

const formatExactDate = (dateString) => {
  if (!dateString) return null;

  const date = dayjs(new Date(convertToCST(dateString)));

  return date.format("MMM D, YYYY");
};

const formatEstimatedDate = (dateString) => {
  if (!dateString) return null;

  const date = dayjs(new Date(convertToCST(dateString)));

  return date.format("MMMM YYYY");
};

export default function StockMessage({
  availableForSale,
  quantityAvailable,
  lowStockThreshold,
  dnr,
  cargoReady,
  backorderDate,
  localeStrings,
}) {
  const interpolateDate = (string) => {
    return string
      .replace("[exact_date]", formatExactDate(backorderDate))
      .replace("[estimated_date]", formatEstimatedDate(backorderDate));
  };

  const messages = {
    inStock: {
      tooltip: localeStrings.tooltip_in_stock,
      lines: [
        {
          text: localeStrings.in_stock.line_1,
          color: "var(--color-secondary)",
        },
      ],
    },
    lowStock: {
      tooltip: localeStrings.tooltip_low_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.low_stock.line_1),
          color: "var(--color-secondary)",
        },
      ],
    },
    outOfStock: {
      tooltip: null,
      lines: [
        {
          text: interpolateDate(localeStrings.out_of_stock.line_1),
          color: "var(--color-tertiary)",
        },
      ],
    },
    reserveNow: {
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.reserve_now.line_1),
          color: "var(--color-tertiary)",
        },
      ],
    },
    reserveNowDate: {
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.reserve_now_date.line_1),
          color: "var(--color-tertiary)",
        },
        {
          text: interpolateDate(localeStrings.reserve_now_date.line_2),
        },
      ],
    },
    notifyMe: {
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.notify_me.line_1),
          color: "var(--color-tertiary)",
        },
      ],
    },
    notifyMeDate: {
      tooltip: localeStrings.tooltip_out_of_stock,
      lines: [
        {
          text: interpolateDate(localeStrings.notify_me_date.line_1),
          color: "var(--color-tertiary)",
        },
        {
          text: interpolateDate(localeStrings.notify_me_date.line_2),
        },
      ],
    },
  };

  const message = stockMessage({
    availableForSale,
    quantityAvailable,
    lowStockThreshold,
    dnr,
    cargoReady,
    backorderDate,
    messages,
  });

  return <StockMessageContent message={message} />;
}
